import React from 'react';

import { MDText } from 'i18n-react';

import { GuideAuthor, WordpressData } from '../../@types/Wordpress';

import { GuideAuthorCard } from './GuideAuthorCard/GuideAuthorCard';
import LocalTexts from './GuideAuthorsContent.text.json';

import styles from './GuideAuthorsContent.module.scss';

export type AuthorContentProps = {
  data: WordpressData | null;
};

const LocalT = new MDText(LocalTexts);

export const GuideAuthorsContent: React.FC<AuthorContentProps> = ({ data }) => {
  const { guideAuthors, title } = data || {};

  return (
    <>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.description}>
        <p data-thc-style-override>{LocalT.translate('description')}</p>
        <p>{LocalT.translate('findOutMore')}</p>
      </div>
      <div className={styles.authorsGrid}>
        {guideAuthors?.map((author: GuideAuthor) => {
          const { id, image, jobTitle, name } = author;
          return (<GuideAuthorCard
            key={id}
            ctaLabel={LocalT.translate('authors.cta') as string}
            ctaLink={`/guides/authors/${id}`}
            title={name}
            {...{ image, jobTitle }}
          />);
        })}
      </div>
    </>
  );
};
